import { BrandJusIa, BrandJusSolucoes, Modal, Spinner } from '@farol-ds/react'
import cn from 'classnames'
import { useEffect, useState } from 'react'

import { BillingElements } from '../billing-elements'
import { CHECKOUT_MESSAGES, CheckoutMessagePayload } from '../types'
import { BillingCheckoutInline } from './checkout-inline'
import styles from './checkout-modal.module.scss'

export type BillingCheckoutBrand = 'jusbrasil' | 'jusia' | 'jusolucoes'

const BRAND_COMPONENTS = {
  jusbrasil: <Modal.HeaderBrand />,
  jusia: <BrandJusIa onlySymbol width={28} />,
  jusolucoes: <BrandJusSolucoes onlySymbol width={28} />,
}

function getTitle(payload?: CheckoutMessagePayload): string | undefined {
  const title = payload?.title
  return typeof title === 'string' ? title : undefined
}

function useCheckoutLoadedTitle(elementContext: BillingElements): string | undefined {
  const [title, setTitle] = useState<string | undefined>(undefined)

  useEffect(() => {
    setTitle(undefined)
    const unsubLoaded = elementContext.on(CHECKOUT_MESSAGES.LOADED, (payload) => {
      setTitle(getTitle(payload))
    })
    const clearTitle = () => setTitle(undefined)
    const unsubSuccess = elementContext.on(CHECKOUT_MESSAGES.PAYMENT_SUCCESS, clearTitle)
    const unsubProcessing = elementContext.on(CHECKOUT_MESSAGES.PAYMENT_PROCESSING, clearTitle)
    return () => {
      unsubLoaded()
      unsubSuccess()
      unsubProcessing()
    }
  }, [elementContext])

  return title
}

export interface BillingCheckoutModalProps {
  elementContext: BillingElements
  open: boolean
  onOpenChange: (open: boolean) => void
  brand?: BillingCheckoutBrand
  isLoaded?: boolean
}

export function BillingCheckoutModal({
  elementContext,
  open,
  onOpenChange,
  brand,
  isLoaded = true,
}: BillingCheckoutModalProps) {
  const heading = useCheckoutLoadedTitle(elementContext)

  const brandComponent = brand ? BRAND_COMPONENTS[brand] : null

  const checkoutWrapperClassName = cn(styles.modalWrapper, !isLoaded && styles.modalWrapperHidden)

  return (
    <Modal size="md" open={open} onOpenChange={onOpenChange}>
      <Modal.Content>
        <Modal.IconClose />
        <header className={styles.modalHeader}>
          <div className={styles.headerRow}>
            {brandComponent}
            {heading && <Modal.HeaderTitle>{heading}</Modal.HeaderTitle>}
          </div>
        </header>
        <Modal.Body className={styles.modalBody} disablePadding>
          {!isLoaded && (
            <div className={styles.loadingContainer}>
              <Spinner size="lg" />
            </div>
          )}
          <BillingCheckoutInline
            elementContext={elementContext}
            className={checkoutWrapperClassName}
          />
        </Modal.Body>
      </Modal.Content>
    </Modal>
  )
}
